import { Routes, Route, useNavigate } from "react-router-dom";
// Material-UI imports
import Grid from "@mui/material/Grid";
import NavBar from "./components/NavBar";


// MSAL imports
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "@front-ends/common/src/utils/NavigationClient";

// Sample app imports
import { PageLayout } from "@front-ends/common/src/components/ui/PageLayout";
import { Profile } from "@front-ends/common/src/pages/Profile";
import { Home } from "./modules/EndPointGed/Home";
import { loginRequest as loginRequestGed} from "./authConfigGed";

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps|any) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);
  
  return (
    <MsalProvider instance={pca}>
      <PageLayout NavBar={NavBar}>
          <Grid container justifyContent="center">
              <Pages />
          </Grid>
      </PageLayout>
    </MsalProvider>
  )
}

function Pages() {
  return (
    <Routes>
      <Route path="/profile" element={<Profile loginRequest = {loginRequestGed}/>} />
      <Route path="/" element={<Home/>} />
    </Routes>
  );
}
export default App
